export default "__VITE_ASSET__Cqa8Cxbd__"